export default function popupLGPD() {
    const content = $('#cookie-banner-lgpd');
    const prosseguir = $('.cookie-banner-lgpd_accept-button');
  
    if (localStorage.getItem('popupLGPD')) {
      content.hide();
    } else {
      content.css('display', 'flex');
    }
  
    prosseguir.click(() => {
      content.hide();
      localStorage.setItem('popupLGPD', true);
    })
}